/**
 * This function is to access browser utilities
 */
var browserUtil = function(){
	var userDetails = {};

	return{
		setUserDetails:function(userObj){
			try{
				if(typeof userObj === "string"){
					userDetails = JSON.parse(userObj);
				}else if(typeof userObj === "object"){
					userDetails = userObj;
				}
			}catch(e){
				console.error(e);
			}
		},
		getUserDetails:function(){
			return userDetails;
		},
		getCookie: function(cname) {
			try{
				var name = cname + "=";
				var ca = document.cookie.split(';');
				for(var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) === ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) === 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			}catch(e){
				if(console)
					console.log(e);
				return "";
			}
		},
		clearCookie: function(cname){
			try{	
				document.cookie = cname+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
			}catch(e){
				if(console)
					console.log(e);
			}
		},
		getUserName:function(){
			return userDetails.userName;
		},	
		getUserId:function(){
			return userDetails.userId;
		},
		getLoginId:function(){
			return userDetails.loginId;
		},
		getCountry:function(){
			return userDetails.country;
		},
		getLanguage:function(){
			return userDetails.language;
		},
		getUserRole:function(){
			return userDetails.userRole.role;
		},
		getAuthToken:function(){
			var authToken = browserUtil.getCookie("_rToken") ? browserUtil.getCookie("_rToken") : "";
			return authToken;
		},
		getLumosToken:function(){
			var authToken = browserUtil.getCookie("authToken") ? browserUtil.getCookie("authToken") : "";
			return authToken;
		}
	};
}();

export default browserUtil;


// WEBPACK FOOTER //
// ./src/util/BrowserUtil.js